import React from 'react';
import { isBoolean, isObject } from '../helpers';

export default function ValueRenderer({ value, fieldName }) {
  // For boolean fields, null should show empty circle
  const isBooleanField =
    fieldName === 'autoConfirmEnabled' ||
    fieldName === 'isIncludedAccomodation' ||
    fieldName === 'isActive' ||
    fieldName === 'isPublished';

  if (value === null || value === undefined) {
    if (isBooleanField) {
      return (
        <i className="fa-regular fa-circle w-4 h-4 text-gray-400 inline" />
      );
    }
    return <em className="text-gray-400">null</em>;
  }

  if (isBoolean(value)) {
    return value ? (
      <i className="fa-regular fa-circle-check w-4 h-4 text-green-600 inline" />
    ) : (
      <i className="fa-regular fa-circle-xmark w-4 h-4 text-gray-400 inline" />
    );
  }

  if (isObject(value)) {
    return (
      <span className="text-gray-500">
        {JSON.stringify(value).slice(0, 50)}...
      </span>
    );
  }

  return <span>{String(value)}</span>;
}
